import { gql } from '@apollo/client';

const flowForwardSearch = gql`
  query flowForwardSearch($exchangeItems: [Int!], $reference: String!, $currency: String!) {
    flowForwardSearch(exchangeItems: $exchangeItems, reference: $reference, currency: $currency) {
      outbound {
        ...exchangeOffer
      }
      inbound {
        ...exchangeOffer
      }
      passengers {
        type
      }
    }
  }

  fragment exchangeOffer on Offer {
    isWheelchair
    totalPriceOfOriginalExchangeItems
    origin {
      uic
      name
    }
    destination {
      uic
      name
    }
    productFamilies {
      name
      code
      familyGroup
    }
    classesOfService {
      code
      name
    }
    journeys {
      timing {
        departs
        arrives
        duration
      }
      fares {
        buckets {
          code
          price
          passengerType
          availability
          physicalAvailability
          highestBucketCodeLogicalAvailability
          __typename
        }
        legs {
          serviceName
          trainNumber
          serviceIdentifier
          classOfService {
            code
            name
          }
          serviceType {
            name
            code
            brandCode
          }
          origin {
            name
            uic
            shortCode
          }
          destination {
            name
            uic
            shortCode
          }
          timing {
            departureDate
            departs
            arrives
            duration
          }
          products {
            passengerId
            tariffCode
            price
          }
        }
        fees {
          tariffCode
          price
          name
          passengerId
          code
        }
        productFamily {
          code
          name
          familyGroup
        }
        classOfService {
          code
          name
        }
        canBeBooked
        isLyria @client
        isSummatedFare
        isThroughFare
        prices {
          displayPrice
        }
        bookingItems {
          passengerId
          tariffCode
          price
        }
      }
    }
  }
`;

export default flowForwardSearch;
